import React, { FC } from 'react';
import Button from 'shared/components/andtComponents/Button';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import GovernanceTagAutocompleteDropdown from 'governanceTags/components/tagAutocompleteDropdown/TagAutocompleteDropdown';
import { GovernanceTag, DropdownType, TagField } from '../../../types';
import styles from '../GovernanceTagsModal.module.scss';

const DeleteIcon = () => <GenerateIcon iconName={ICONS.deleteRegular.name} />;

interface TagRowProps {
  tag: GovernanceTag;
  index: number;
  isSelected: boolean;
  isLoading?: boolean;
  availableTagKeys: string[];
  availableTagValues: string[];
  onTagChange: (index: number, field: TagField, value: string) => void;
  onTagSelect: (index: number, field: TagField, value: string, isNew: boolean) => void;
  onRemoveTag: (index: number) => void;
  onSelectTag: (index: number, checked: boolean) => void;
  onCreateNewKey: (index: number) => void;
  onCreateNewValue: (index: number) => void;
}

const TagRow: FC<TagRowProps> = ({
  tag,
  index,
  isSelected,
  isLoading = false,
  availableTagKeys,
  availableTagValues,
  onTagChange,
  onTagSelect,
  onRemoveTag,
  onSelectTag,
  onCreateNewKey,
  onCreateNewValue,
}) => {
  const handleRemoveClick = () => {
    onRemoveTag(index);
  };

  const isValueDropdownDisabled = !tag.name || tag.name.trim() === '';

  return (
    <div className={styles.tagRow}>
      <input
        type="checkbox"
        id={`selectTag_${index}`}
        checked={isSelected}
        onChange={(e) => onSelectTag(index, e.target.checked)}
        disabled={isLoading}
      />
      <div className={styles.tagInputs}>
        <GovernanceTagAutocompleteDropdown
          key={`key-dropdown-${index}`}
          label="Select"
          options={availableTagKeys}
          value={tag.name}
          onChange={(value: string) => onTagChange(index, TagField.NAME, value)}
          onSelect={(value: string, isNew: boolean) => onTagSelect(index, TagField.NAME, value, isNew)}
          dropdownType={DropdownType.KEY}
          showCreateOption
          onCreateButtonClick={() => onCreateNewKey(index)}
        />
        <GovernanceTagAutocompleteDropdown
          key={`value-dropdown-${index}`}
          label="Select"
          options={availableTagValues}
          value={tag.value}
          onChange={(value: string) => onTagChange(index, TagField.VALUE, value)}
          onSelect={(value: string, isNew: boolean) => onTagSelect(index, TagField.VALUE, value, isNew)}
          dropdownType={DropdownType.VALUE}
          showCreateOption
          onCreateButtonClick={() => onCreateNewValue(index)}
          disabled={isValueDropdownDisabled}
        />
      </div>
      <Button
        isTextButton
        text=""
        automationid="single-tag-remove"
        icon={DeleteIcon}
        onClick={handleRemoveClick}
        className={styles.singleRemoveButton}
        disabled={isLoading}
      />
    </div>
  );
};

export default TagRow;
